import React, { createContext, useState } from "react";

export const PageContext = createContext();

export const PageProvider = ({ children }) => {
	const [currentPage, setCurrentPage] = useState("Hot");
	const [viewMode, setViewMode] = useState("list"); // "list" or "tile"

	return (
		<PageContext.Provider value={{ currentPage, setCurrentPage, viewMode, setViewMode }}>
			{children}
		</PageContext.Provider>
	);
};
